/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetFlagConfigDependenciesPathParams = NonNullable<
  operations['internalGetFlagConfigDependencies']['parameters']['path']
>;

export type InternalGetFlagConfigDependenciesRequestBody = OperationRequestBodyContent<
  operations['internalGetFlagConfigDependencies']
>;

export interface Input extends InternalGetFlagConfigDependenciesPathParams {
  apiVersion?: string;
  body: InternalGetFlagConfigDependenciesRequestBody;
}

export async function internalGetFlagConfigDependencies(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/environments/{environmentKey}/flags/config-dependencies', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
